import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import AutoBindComponent from "../common/AutoBindComponent";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

import { Dropdown } from "semantic-ui-react";

class AutoCompleteComponent extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.MINSEARCHLENGTH = 1;
		this.MAXITEMCOUNT = 10;

		this.state = {
			search: ''
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (this.props.items.length !== nextProps.items.length)
			|| this.props.value !== nextProps.value
			|| this.state.search !== nextState.search
			|| this.props.validationMessage !== nextProps.validationMessage
			|| this.props.disabled !== nextProps.disabled;
	}

	handleOnSearch(e, value) {
		const options = [];
		if (value.searchQuery.length > this.MINSEARCHLENGTH) {
			const regexpToSearch = new RegExp("^" + value.searchQuery, "i");
			const searchresults = this.props.items.filter(item => item.label.match(regexpToSearch));

			for (let i = 0; i < searchresults.length; i++) {
				options.push({ text: searchresults[i].label, value: searchresults[i].value });
			}
		}
		const state = { options: options, search: value.searchQuery };

		this.setState(state);
	}

	handleOnChange(e, data) {
		if (this.props.onChange) {
			this.props.onChange(e, data);
		}
	}

	getLabelItemByValue(value, noId) {
		if (!noId) {
			let label = "";
			const item = this.props.items.find(item => item.value == value);
			if (item != null) {
				label = item.label;
			}
			return label;
		}
		return value;
	}

	render() {
		const noId = this.props.hasNoId;
		const maxItemCount = this.props.maxItemCount ? this.props.maxItemCount : 10;
		const hasValue = !!this.props.value;
		const hasValidationMessage = !!this.props.validationMessage;
		const validationMessageType = this.props.validationMessageType;
		const tooltiptype = this.props.tooltipType || types.TOOLTIP_INFO;
		const defaultItem = this.props.defaultItem ? this.props.defaultItem : "Kies een optie";
		const value = this.props.value ? this.props.value : "";
		const valueIndex = this.props.items.map(item => item.value).indexOf(this.props.value);
		const sizeClassName = this.props.size ? "o-col-" + this.props.size : "o-col-12";
		const label = this.props.label + (this.props.optional ? " (Optioneel)" : "");
		const info = this.props.tooltip ? <Tooltip isInput text={this.props.tooltip} tooltipType={tooltiptype} /> : null;
		const validation = this.props.validationMessage ? <ValidationMessage validationMessage={this.props.validationMessage} type={validationMessageType} /> : null;
		const icon = 'search';
		const id = generateGuid();
		const noResultsMessage = this.props.noResultsMessage ? this.props.noResultsMessage : 'Tik (2 letters) en zoek';
		let text = "";

		const inputClassName = classnames({
			"c-input__field": true
		});
		const labelClassName = classnames({
			"c-input__label": true,
			"has-value": true
		});

		const containerClassName = classnames({
			"c-input": true,
			"c-input--dropdown": true,
			"has-value": true,
			"error": hasValidationMessage,
			"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
			"disabled": this.props.disabled
		});

		if (value) {
			text = this.getLabelItemByValue(value, noId);
		}

		const options = this.state.options ? this.state.options : [];
		return (
			<div className={sizeClassName}>
				<div className={containerClassName}>
					<Dropdown
						id={id}
						className={inputClassName}
						fluid
						text={text}
						selection
						icon={icon}
						search
						name={this.props.name}
						closeOnChange
						options={options}
						placeholder={defaultItem}
						onChange={this.handleOnChange}
						disabled={this.props.disabled}
						loading={this.props.loading}
						onSearchChange={this.handleOnSearch}
						noResultsMessage={noResultsMessage}
					/>
					<label className={labelClassName} htmlFor={id}>{label}</label>
					{info}
				</div>
				{validation}
			</div>
		);
	}
}

AutoCompleteComponent.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	items: PropTypes.array.isRequired,
	loading: PropTypes.bool,
	hasNoId: PropTypes.bool,
	noResultsMessage: PropTypes.string
};

export default AutoCompleteComponent;
